module.exports = __webpack_public_path__ + "media/images/email_second-979764ca6e6270d736efa098712acc8c.png";